import type { ValidationErrors } from "@/api/util";

export class BidError extends Error {
  fields: ValidationErrors;
  status?: number;

  constructor(message: string, fields: ValidationErrors = {}, status?: number) {
    super(message);
    this.name = "BidError";
    this.fields = fields;
    this.status = status;
  }
}

export class CancelBidError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = "CancelBidError";
    this.status = status;
  }
}

export class NotFoundError extends Error {
  constructor(message: string) {
    super(`The requested resource could not be found: ${message}`);
    this.name = "NotFoundError";
  }
}
